import { render, staticRenderFns } from "./AssignRole.vue?vue&type=template&id=02a477e4"
import script from "./AssignRole.vue?vue&type=script&lang=ts"
export * from "./AssignRole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports